/**
 * @typedef {keyof typeof ATTACK_KEYS} AttackKeys
 */

/** @enum {AttackKeys} */
export const ATTACK_KEYS = Object.freeze({
  ICE_SHARD: 'ICE_SHARD',
  SLASH: 'SLASH',
});
